export const smkmoduleIds = {
  bigScreen: 3,
  seminar: 3,
  webinar: 2,
  memberForm: 11,
  customForm: 7,
  question: 8,
  poll: 10,
  luckyDraw: 9,
  topic: 24,
  fileFolder: 12,
  file: 12,
  articleCategory: 26,
  article: 26,
  scms: 36,
};

export const smkmoduleTypes = [
  { id: "bigScreenId", type: "bigScreen" }, // 线下会大屏
  { id: "seminarId", type: "seminar" }, // 线下会专题站
  { id: "webinarId", type: "webinar" }, // 线上会直播，点播
  { id: "memberFormId", type: "memberForm" }, // 注册表单
  { id: "customFormId", type: "customForm" }, // 表单
  { id: "questionaryId", type: "question" }, // 问卷
  { id: "pollId", type: "poll" }, // 投票
  { id: "luckyDrawId", type: "luckyDraw" }, // 抽奖
  { id: "topicId", type: "topic" }, // 微讨论 互动社区
  { id: "folderId", type: "fileFolder" }, // 文件模板文件夹
  { id: "fileId", type: "file" }, // 文件模板文件
  { id: "articleCategoryId", type: "articleCategory" }, // 文章栏目
  { id: "articleId", type: "article" }, // 文章
  { id: "sid", type: "scms" }, // 营销建站
  { id: "instanceId", type: "instance" }, // 实例ID
];
